import {findClosest} from '../../util/miscellaneous';

function toggleFieldset (fieldset) {
  if (!fieldset.classList.contains('expanded')) {
    fieldset.classList.add('expanded');
  } else {
    fieldset.classList.remove('expanded');
  }
}

function filterProducts (checked) {
  const fieldset = findClosest(checked, '.fieldset');
  const productList = fieldset.querySelectorAll('.product-list .product');
  const setFilters = [];
  fieldset.querySelectorAll('.filter input:checked').forEach((filter) => {
    // collect all current set filters
    setFilters.push(filter.value);
  });
  if (setFilters.length > 0) {
    productList.forEach((product) => {
      // now display the related products, assume
      const productFilters = product.getAttribute('data-filters');
      let match;
      setFilters.forEach((filter) => {
        // only need a single match, if one matches carry it through
        match = match === true ? true : productFilters.includes(filter);
      });
      if (match === true) {
        product.classList.remove('not-matching');
      } else {
        product.classList.add('not-matching');
      }
    });
  } else {
    // nothing selected, display all
    productList.forEach((product) => {
      product.classList.remove('not-matching');
    });
  }
}

function checkEnableSubmit (bindingTool) {
  let disabled;
  bindingTool.querySelectorAll('.fieldset:not(.disabled)').forEach((fieldset) => {
    if (disabled === true) {
      // carry through / break
      disabled = true;
    } else if (fieldset.querySelector('.product-list') &&
        !fieldset.querySelector('.product-list input:checked')) {
      disabled = true;
    } else if (fieldset.querySelector('.product-list input:checked').getAttribute('data-edging-style') &&
        !fieldset.querySelector('.edging-width input:checked')) {
      disabled = true;
    } else {
      // clean
      disabled = false;
    }
  });
  if (disabled === false) {
    // all good show button
    bindingTool.querySelectorAll('.summary button').forEach((button) => {
      button.disabled = false;
    });
  } else {
    bindingTool.querySelectorAll('.summary button').forEach((button) => {
      button.disabled = true;
    });
  }
}

function updateSelection (checked, bindingTool) {
  const fieldset = findClosest(checked, '.fieldset');
  const group = checked.getAttribute('data-group');
  const img = checked.getAttribute('data-image');
  const name = checked.getAttribute('data-name');
  const measurable = checked.getAttribute('data-measurable');
  const width = checked.getAttribute('data-width');
  // NOTE for edging-* I want to edit the ff margin
  const preview = group === 'edging-style' || group === 'edging-width' ? bindingTool.querySelector('.preview .flooring-fabric') : bindingTool.querySelector(`.preview .${group}`);
  const legend = width ? fieldset.querySelector('.legend .measure') : fieldset.querySelector('.legend .selected');
  const summary = bindingTool.querySelector(`.summary .${group}`);

  // const edgingWidth = fieldset.querySelector('.edging-width');
  const edgingPreview = bindingTool.querySelector('.preview .edging-style');

  // update the relevant fieldgroup
  fieldset.classList.add('populated');
  legend.innerHTML = width ? `, ${name}` : `: ${name}`;
  // display summary text
  summary.innerHTML = name;
  // update preview image url
  if (img) {
    preview.style.backgroundImage = `url('${img}')`;
  }
  // show/hide relevant content, if bind style, has width + material
  if (measurable) {
    preview.style.margin = null;
    edgingPreview.querySelectorAll('.corner').forEach((ep) => {
      ep.style.height = null;
      ep.style.width = null;
    });

    if (measurable === 'True') {
      edgingPreview.setAttribute('class', 'edging-style');
      bindingTool.querySelector('.binding-material').classList.remove('disabled');
      fieldset.classList.add('measurable');
      const edgingStyle = checked.getAttribute('data-edging-style');
      edgingPreview.classList.add(edgingStyle);
    } else if (measurable === 'False') {
      // reset classes
      bindingTool.querySelector('.binding-material').classList.add('disabled');
      fieldset.classList.remove('measurable');
      // reset radios/checkboxes
      const checkedWidth = fieldset.querySelector('.edging-width input:checked');
      if (checkedWidth) {
        checkedWidth.checked = false;
      }
      const checkedMaterial = bindingTool.querySelector('.binding-material .product-list input:checked');
      if (checkedMaterial) {
        checkedMaterial.checked = false;
      }
      // reset legends
      fieldset.querySelector('.legend .measure').innerHTML = '';
      bindingTool.querySelector('.binding-material .legend .selected').innerHTML = '';
      // reset summaries
      bindingTool.querySelector('.summary .edging-width').innerHTML = '';
      bindingTool.querySelector('.summary .binding-material').innerHTML = '';
      // reset preview
      preview.style.margin = '0px';
    }
  }
  if (width) {
    preview.style.margin = `${width / 2}px`;
    edgingPreview.querySelectorAll('.corner').forEach((ep) => {
      ep.style.height = `${width / 2}px`;
      ep.style.width = `${width / 2}px`;
    });
  }

  checkEnableSubmit(bindingTool);
}

export function bindingToolInit (bindingTool) {
  // initial call if preselected
  bindingTool.querySelectorAll('.product input:checked, .edging-width input:checked').forEach((radiobox) => {
    updateSelection(radiobox, bindingTool);
  });

  // bind legend click
  bindingTool.querySelectorAll('.legend').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      toggleFieldset(trigger.parentElement);
    });
  });
  // bind filters
  bindingTool.querySelectorAll('.filter input').forEach((radiobox) => {
    radiobox.addEventListener('change', (e) => {
      filterProducts(radiobox);
    });
  });
  // bind product selection
  bindingTool.querySelectorAll('.product input, .edging-width input').forEach((radiobox) => {
    radiobox.addEventListener('change', (e) => {
      updateSelection(radiobox, bindingTool);
    });
  });
}



// WEBPACK FOOTER //
// ./assets/j/src/collection/binding-tool.js